export const patientsActionTypes = {
  selectLocations: "PATIENTS_SELECT_LOCATIONS",
  deselectLocations: "PATIENTS_DESELECT_LOCATIONS",
  setPatientSearchString: "PATIENTS_SET_PATIENT_SEARCH_STRING",
  setRevisionsTablePageLimit: "PATIENTS_SET_REVISIONS_TABLE_PAGE_LIMIT",
  enableRevisionToBeEdited: "PATIENTS_ENABLE_REVISION_TO_BE_EDITED"
};
